import type { ApolloClient } from '@apollo/client';
import { MUTATION_REFRESH_TOKENS } from './mutations/auth';

const AUTH_ROUTES = ['/login', '/register', '/forgot', '/recover', '/reset', '/configured', '/setupmfa', '/select-tenant'];

let clientRef: ApolloClient<any> | null = null;
let forceLogoutFn: (() => void) | null = null;
let inflight: Promise<void> | null = null;

export const setRefreshClient = (c: ApolloClient<any>) => {
    clientRef = c;
};

export const setForceLogoutHandler = (fn: () => void) => {
    forceLogoutFn = fn;
};

export const forceLogout = () => {
    if (forceLogoutFn) {
        forceLogoutFn();
        return;
    }
    const isAuthRoute = AUTH_ROUTES.some((r) => window.location.pathname.includes(r));
    if (!isAuthRoute) {
        window.location.href = '/login';
    }
};

export const refreshTokens = (): Promise<void> => {
    if (inflight) return inflight;
    if (!clientRef) return Promise.reject(new Error('Apollo client not set for refresh'));

    inflight = clientRef
        .mutate({
            mutation: MUTATION_REFRESH_TOKENS,
            fetchPolicy: 'no-cache',
            errorPolicy: 'none'
        })
        .then(() => undefined)
        .finally(() => {
            inflight = null;
        });

    return inflight;
};
